import React from 'react'

import { createFileRoute } from '@tanstack/react-router'

import Footer from '@/components/landing/footer'
import Navbar from '@/components/landing/navbar'
import WhatsAppFloatingButton from '@/components/ui/whatsapp-floating'

import AboutSection from './-components/about-section'
import ActivitiesSection from './-components/activity-section'
import ContactSection from './-components/contact-section'
import Hero from './-components/hero'
import MapJapan from './-components/map-japan'
import OfficeSection from './-components/office-section'
import TeamSection from './-components/team-section'
import ValuesSection from './-components/values-section'
import VisionMissionSection from './-components/vission-mission'

export const Route = createFileRoute('/about-us/')({
  component: Component,
})

function Component() {
  return (
    <>
      <div className="relative min-h-screen w-full bg-[#f7f8ff] font-['Poppins']">
        {/* Background Map */}
        <MapJapan />
        {/* Background Blur Effect */}
        <div className="absolute right-0 top-[-176px] h-[215px] w-[215px] rounded-full bg-[#d9202e] opacity-100 blur-[110px]" />

        {/* Navigation */}
        <Navbar />

        {/* Main Content */}
        <main className="relative z-10 mt-12">
          <Hero />
          <AboutSection />
          <VisionMissionSection />
          <ValuesSection />
          <TeamSection />
          <ActivitiesSection />
          <OfficeSection />
          <ContactSection />
        </main>

        <WhatsAppFloatingButton />
        {/* Footer */}
        <Footer />
      </div>
    </>
  )
}
